import { Area, Freeze, Sheet } from '../../types';
import { v4 as uuid } from 'uuid';
import { EntityIdToName } from '../../types/sheet/sheetGroups';
import _ from 'lodash';
import { SheetDefaults } from '../../constants/sheetDefaults';
import { HeaderGroup } from '../../types/sheet/headerGroups';
import { testPartialSheet } from './testData';

// TODO: Remove this
export const getUniqueSheetName = (sheetsIdToName: EntityIdToName): string => {
  const existingNames: Set<string> = new Set();

  _.values(sheetsIdToName).forEach((sheetName) =>
    existingNames.add(sheetName.toLowerCase())
  );

  let newIndex = 1;
  let newName = `Sheet${newIndex}`;

  while (existingNames.has(newName.toLowerCase())) {
    newIndex++;
    newName = `Sheet${newIndex}`;
  }

  return newName;
};

export function getSheetNameFromId(
  sheetId: string,
  sheetsIdToName: EntityIdToName
  // sheetGroups: SheetGroups
): string | undefined {
  return sheetsIdToName[sheetId];
  // for (const groupId in sheetGroups) {
  //   const group = sheetGroups[groupId];
  //   const sheet = group.sheetsMetaData.find(
  //     (sheet) => sheet.sheetId === sheetId
  //   );
  //   if (sheet) {
  //     return sheet.sheetName;
  //   }
  // }
  // return undefined; // Sheet ID not found
}

// export function getSheetIdFromName(
//   sheetName: string,
//   sheetGroups: SheetGroups
// ): string | undefined {
//   for (const groupId in sheetGroups) {
//     const group = sheetGroups[groupId];
//     const sheet = group.sheetsMetaData.find(
//       (sheet) => sheet.sheetName === sheetName
//     );
//     if (sheet) {
//       return sheet.sheetId;
//     }
//   }
//   return undefined; // Sheet name not found
// }

const createDynamicTopSheetSection = () => ({
  // groupBar: {
  //   isVisible: true, //true,
  //   height: SheetDefaults.groupBarHeight, //* 2
  // },
  columnHeaderBar: {
    isVisible: true,
    height: SheetDefaults.columnHeaderHeight,
  },
  filterBar: {
    isVisible: true,
    height: SheetDefaults.filterBarHeight,
  },
});

const createTopSheetSection = () => ({
  formulaBar: {
    isVisible: true,
    height: SheetDefaults.formulaBarHeight,
  },
});

const createRightSheetSection = () => ({
  shortcutBar: {
    isVisible: false, // true
    width: SheetDefaults.rightShortcutBarWidth,
  },
  // scrollBar: {
  //   isVisible: true,
  //   width: 10,
  // },
});

const createLeftSheetSection = () => ({
  // rowGroupBar: {
  //   isVisible: true, //true,
  //   width: SheetDefaults.rowGroupBarWidth, // * 2
  // },
});

const createBottomSheetSection = () => ({
  // scrollBar: {
  //   isVisible: true,
  //   height: 10,
  // },
  // statusBar: {
  //   isVisible: true,
  //   height: 25,
  // },
});

export const defaultFreeze = (): Freeze => ({
  // frozen: true,
  // start: 0,
  // end: 5,

  frozen: false,
  start: -1,
  end: -1,
});

// {
//   frozen: false,
//   start: -1,
//   end: -1,
// }
// {
//   frozen: true,
//   start: 0,
//   end: 2,
// }
// export const defaultFilterResult = (): FilterResult => ({
//   // hasFilter: true,
//   // rowIndexes: [2, 7, 15, 17, 18], //[2, 4, 6],
//   // lastRow: 20,
//   // frozenFilteredRows: 1

//   hasFilter: false,
//   rowIndexes: [],
//   lastRow: -1,
//   frozenFilteredRows: 0,
// });

// {
//   hasFilter: true,
//   rowIndexes: [2, 4, 6],
//   lastRow: 10,
//   frozenFilteredRows: 1
// }
// {
//   hasFilter: false,
//   rowIndexes: [],
//   lastRow: -1,
//   frozenFilteredRows: 0
// }

const mergeAddresses: string[] = ['C8:C18', 'D1:E3'];
const mergedAreas: Area[] = [
  {
    start: { ci: 2, ri: 7 },
    end: { ci: 2, ri: 18 },
  },
  // {
  //   start: { ci: 1, ri: 8 },
  //   end: { ci: 1, ri: 17 },
  // },
  // {
  //   start: { ci: 1, ri: 1 },
  //   end: { ci: 1, ri: 5 },
  // },
  {
    start: { ci: 3, ri: 0 },
    end: { ci: 4, ri: 2 },
  },
  // { start: { ci: 5, ri: 1 }, end: { ci: 5, ri: 5 } },
  // {
  //   start: { ci: 0, ri: 7 },
  //   end: { ci: 0, ri: 9 },
  // },
];

const pakGroup = {
  id: '2-row',
  start: 20,
  end: 39,
  color: 'teal',
  name: 'United States',
  nestedGroups: [
    {
      id: '2-row-1',
      start: 20,
      end: 29,
      color: 'orange',
      name: '2008',
      nestedGroups: [
        {
          id: '2-row-1-1',
          start: 20,
          end: 24,
          color: 'pink',
          name: '',
          nestedGroups: [],
        },
        {
          id: '2-row-1-2',
          start: 25,
          end: 29,
          color: 'red',
          name: '',
          nestedGroups: [],
        },
      ],
    },
    {
      id: '2-row-2',
      start: 30,
      end: 39,
      color: 'yellow',
      name: '2009',
      nestedGroups: [
        {
          id: '2-row-2-1',
          start: 30,
          end: 34,
          color: 'green',
          name: '',
          nestedGroups: [],
        },
        {
          id: '2-row-2-2',
          start: 35,
          end: 39,
          color: 'purple',
          name: '',
          nestedGroups: [],
        },
      ],
    },
  ],
};

const rowGroups = (): HeaderGroup[] => [
  {
    id: '1-row',
    start: 0,
    end: 19,
    color: 'purple',
    name: 'Pakistan',
    nestedGroups: [
      {
        id: '1-row-1',
        start: 0,
        end: 9,
        color: 'blue',
        name: '2008',
        nestedGroups: [
          {
            id: '1-row-1-1',
            start: 0,
            end: 4,
            color: 'green',
            name: '',
            nestedGroups: [],
          },
          {
            id: '1-row-1-2',
            start: 5,
            end: 9,
            color: 'yellow',
            name: '',
            nestedGroups: [],
          },
        ],
      },
      {
        id: '1-row-2',
        start: 10,
        end: 19,
        color: 'red',
        name: '2009',
        nestedGroups: [
          {
            id: '1-row-2-1',
            start: 10,
            end: 14,
            color: 'orange',
            name: '',
            nestedGroups: [],
          },
          {
            id: '1-row-2-2',
            start: 15,
            end: 19,
            color: 'cyan',
            name: '',
            nestedGroups: [],
          },
        ],
      },
    ],
  },
  pakGroup,
  // {
  //   id: '2-row',
  //   start: 11,
  //   end: 20,
  //   color: 'orange',
  //   name: 'Sport',
  //   nestedGroups: [],
  // },
  // {
  //   id: '3-row',
  //   start: 3,
  //   end: 5,
  //   color: 'blue',
  //   name: 'Prize',
  //   nestedGroups: [],
  // },
  // {
  //   id: '4-row',
  //   start: 7,
  //   end: 20,
  //   color: 'green',
  //   name: '',
  //   nestedGroups: [],
  // },
];

const colGroups = (): HeaderGroup[] => [
  {
    id: '1-col',
    start: 0,
    end: 1,
    color: 'pink',
    name: 'Athelete Name',
    nestedGroups: [],
  },
  {
    id: '2-col',
    start: 2,
    end: 2,
    color: 'orange',
    name: 'Sport',
    nestedGroups: [],
  },
  {
    id: '3-col',
    start: 3,
    end: 5,
    color: 'blue',
    name: 'Prize',
    nestedGroups: [],
  },
  {
    id: '4-col',
    start: 6,
    end: 20,
    color: 'green',
    name: '',
    nestedGroups: [],
  },
];

const randomGroups = () => [
  {
    id: '1',
    start: 0,
    end: 9,
    color: 'purple',
    name: '',
    nestedGroups: [
      {
        id: '1-2',
        start: 0,
        end: 3,
        nestedGroups: [],
        color: 'green',
        name: '',
      },
      {
        id: '1-3',
        start: 6,
        end: 9,
        nestedGroups: [],
        color: 'blue',
        name: '',
      },
    ],
  },
  // {
  //   start: 0,
  //   end: 2,
  //   nestedGroups: [],
  // },
  // {
  //   id: '1',
  //   start: 0,
  //   end: 5,
  //   nestedGroups: [],
  //   color: 'purple',
  // },
];

const randomHiddenRanges = () => [
  // { start: 6, end: 9 },
  // { start: 8, end: 13 },
  // { start: 16, end: 17 },
  // { start: 0, end: 0},
  // {
  //   start: 9,
  //   end: 14,
  // },
  // {start: 3, end: 5},
  // { start: 0, end: 2 },
  // { start: 4, end: 5 },
  // { start: 4, end: 6 },
  // { start: 8, end: 12 },
];

export const generateSheet = (
  ownerId: string,
  name: string,
  sheet: Partial<Sheet> = {}
): Sheet => ({
  id: uuid(), //`${name}k`,

  name,
  description: '',
  remarks: '',

  ownerId,

  colSizes: [],
  rowSizes: [],

  cols: [
    // { id: '1' }, //, width: 25
    // { id: '2' }, // width: 40,
    // { id: '3' }, //  width: 5
    // {id: '4', width: 5}
  ],
  hiddenCols: [], //randomHiddenRanges(),
  colGroups: [], //colGroups(),

  rows: [
    // { id: '1' },
    // { id: '2', height: 70 },
    // { id: '3', height: 55,  },
    // { id: '4', height: 50 },
    // { id: '5', },
  ],
  hiddenRows: [
    // { start: 3, end: 99904 },
    // { start: 99915, end: 99919 },
  ], //randomHiddenRanges(),
  rowGroups: [], //rowGroups(), //randomGroups(),

  cells: [],
  // cellDeps: [],
  dynamicFormulas: [],

  // cells: {},
  // results: {},

  defaultColWidth: SheetDefaults.defaultColWidth,
  defaultRowHeight: SheetDefaults.defaultRowHeight,
  maxColIndex: 105,
  maxRowIndex: 99999,

  zoom: 1,
  lastCreatedCol: -1,
  lastCreatedRow: -1,

  rowsGridCount: 0,

  // filterResult: defaultFilterResult(),

  dynamicTopSection: createDynamicTopSheetSection(),
  topSection: createTopSheetSection(),
  rightSection: createRightSheetSection(),
  leftSection: createLeftSheetSection(),
  bottomSection: createBottomSheetSection(),

  dataValidationMatrix: [],
  dataValidationsMap: {},
  dataValidationRules: {},

  freezedCols: defaultFreeze(),
  freezedRows: defaultFreeze(),

  merges: mergedAreas, // mergeAddresses,

  // deps: [{}],
  cellsReferences: [],
  rangeIndeps: {},
  rangeIndepsMatrix: [],

  styles: {},
  stylesMatrix: [],
  // cellIndeps: [],

  // numberFormats: {},
  numberFormatMatrix: [],

  // cellNumberFormats: {
  // A1: {
  //   type: NumberFormatType.Currency,
  // },
  // },
  numberFormats: {
    // 'A1:C1': {
    //   code: '$ #,##0.00',
    //   type: NumberFormatType.Currency,
    // },
  },
  // conditionalFormats: [
  //   {
  //     id: '1',
  //     ranges: ['A:C'],
  //   },
  // ],
  // dataValidations: {
  // '1': {
  //   id: '1',
  //   ranges: ['A:C', 'DB:DB'],
  //   type: DataValidation.ValidationType.List,
  //   values: {
  //     hasaan: 3,
  //   },
  // },
  // },
  defaultCellStyle: {},

  // protectedRanges: {
  //   '1': {
  //     ranges: ['B1'],
  //   },
  // },
  // sheetProtection: {
  //   excludedRanges: ['A1'],
  // },

  filters: {},
  usersPreferences: {},
  filterViews: {},

  filterSettings: {
    advanceTextSearch: true,
  },

  ...sheet,

  ...testPartialSheet,
});
